module.exports = __webpack_public_path__ + "img/goldenTrophy2.d503385b.png";